import { Option } from '@sapphire/result';

import type {
  SurveyEpcEstimateQuery,
  SurveyMarginFormState,
  SurveyMetadataFormState,
} from '@ps/survey-utils';

export function epcEstimateQuery(
  metadata: SurveyMetadataFormState,
  margin: SurveyMarginFormState,
): SurveyEpcEstimateQuery {
  const metadataValue = Option.from(metadata.value);
  const marginValue = Option.from(margin.value);

  return {
    goal: metadataValue.mapOr(0, ({ completes }) => completes ?? 0),
    incidence: metadataValue.mapOr(0, ({ incidence }) => incidence ?? 0),
    cpi: marginValue.mapOr(0, ({ buyerCpi }) => buyerCpi ?? 0),
    margin: marginValue.mapOr(0, ({ targetMargin }) => targetMargin ?? 0),
  };
}

export function isEpcEstimateRequestable(
  query: SurveyEpcEstimateQuery,
): boolean {
  return !!query.goal && !!query.incidence && !!query.cpi && !!query.margin;
}

export function isSameEpcEstimateQuery(
  previous: SurveyEpcEstimateQuery,
  next: SurveyEpcEstimateQuery,
): boolean {
  return (
    previous.goal === next.goal &&
    previous.incidence === next.incidence &&
    previous.cpi === next.cpi &&
    previous.margin === next.margin
  );
}

export function epcPlatformCountryCode(
  metadata: SurveyMetadataFormState,
  fallback: string,
): string {
  return (
    Option.from(metadata.value)
      .map(({ selectedCountries }) => selectedCountries[0] ?? '')
      .unwrapOr('') || fallback
  );
}
